const dropdown = document.getElementById('dropdown');

if (dropdown) {
    dropdown.addEventListener('click', function () {
        const icon = document.getElementById('dropdownIcon');
        const isOpen = this.classList.toggle('open');

        if (isOpen) {
            icon.classList.add('flipped');
        } else {
            icon.style.transition = "transform 0.5s ease";
            setTimeout(() => {
                icon.classList.remove('flipped');
                setTimeout(() => {
                    icon.style.transition = "transform 0.4s ease";
                }, 800);
            }, 10);
        }
    });
}